import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, message, Modal, Select, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import "./Dashboard.css";
import "./Timeline.css";
import {
  selectProfile,
  selectShortTermGoals,
  selectTimeline,
  selectTimelineStep,
  setShortTermGoalsAsync,
  setShortTermGoalsConflict,
  setTimelineAsync,
  setTimelineStepAsync,
  updateHoursPerWeekCommitmentAsync,
  updateShortTermGoals,
  updateTimeline,
} from "slices/dashboardSlice";
import HELPERS from "utils/helper";
import {
  TIMELINE_AREAS,
  getWidth,
  newGetWidth,
  monthsBeforeToday,
  setTimelinePercentage,
  getMonths,
  getMonthsWithYears,
  splitAndUpdateSTG,
  mergeOrSplitPhase,
  getMonthsWithYearsFromCurrent,
} from "utils/timeline";

import TimelineCardPopup, {
  EditCardPopup,
  EditCardPopup2,
} from "Components/ReusableComponents/TimelineCardPopup";
import PopupForm from "Components/ReusableComponents/PopupForm";
import StaircaseFlow from "Components/ReusableComponents/starecaseChart";
import useCustomizeDash from "../../hooks/useCustomizeDash";
import DASHBOARD_API from "api/dashboard";
import { getTextWidth, getTextWidthInDecimals } from "utils/shortTermGoals";
import RoadmapDisplayTitle from "Components/ReusableComponents/roadmapDisplayTitle";

const { Option } = Select;

const Timeline = ({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) => {
  const profile = useSelector(selectProfile);
  const dispatch = useDispatch();
  const today = moment();
  const sectionRef = React.createRef();
  const [marginLeft, setMarginLeft] = useState("0");
  const [popupData, setPopupData] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [form2Open, setForm2Open] = useState(false);
  const [goalStepID, setGoalStepID] = useState(null);
  const [goalDesc, setGoalDesc] = useState("");
  const [goalDueDate, setGoalDueDate] = useState("");
  const [showRemovedPhase, setShowRemovedPhase] = useState(false)
  
  const hoursPerWeekCommitment = profile ? profile.hours_per_week_commitment : 0;
  const joinedOn = profile ? moment(new Date(profile.date_joined)) : today;
  const { isDropdownOpen } = useCustomizeDash();
  HELPERS.log("Updated Timeline", profile);
  const userId = HELPERS.getUserId();

  const timelineData = useSelector(selectTimeline);
  const shortTermGoals = useSelector(selectShortTermGoals);
  console.log('sss timelineData', timelineData)
  const timelineStep = useSelector(selectTimelineStep);
  const isPopupVisibleRef = useRef(null);

  // Function to handle outside click
    const handleClickOutside = (event) => {
      const sectionRight = document.querySelector(".main-right-container");
      const sectionLeft = document.querySelector(".main-left-container");
      
      if (
        (isPopupVisible || formOpen || form2Open) &&
        (sectionRight && sectionRight.contains(event.target) || sectionLeft && sectionLeft.contains(event.target) ) &&
        isPopupVisibleRef.current && !isPopupVisibleRef.current.contains(event.target)
      ) {
        setPopupVisible(false)
        setPopupData(null)
        setFormOpen(false)
        setForm2Open(false)
        dispatch(setShortTermGoalsConflict(false));
      }
    };

    const handleHoverOutsite = (event) => {

      console.log('sss handleHoverOutsite event', event)
       const sectionRight = document.querySelector(".timeline.section.blank");
        if (
        (isPopupVisible || formOpen || form2Open) &&
        (!sectionRight && sectionRight.contains(event.target) ) &&
        isPopupVisibleRef.current && !isPopupVisibleRef.current.contains(event.target)
      ) {
        setPopupVisible(false)
        setPopupData(null)
        setFormOpen(false)
        setForm2Open(false)
        dispatch(setShortTermGoalsConflict(false));
      }

    }
  
    useEffect(() => {
      if ((isPopupVisible || formOpen || form2Open)) {
        document.addEventListener("click", handleClickOutside);
        // document.addEventListener("mouseover", handleHoverOutsite);
      }
      return () => {
        document.removeEventListener("click", handleClickOutside);
        // document.removeEventListener("mouseover", handleHoverOutsite);
      };
    }, [isPopupVisible, formOpen, form2Open]);

  const handleItemClick = (event, itemData) => {
    // Get the position of the clicked span element
    // console.log('sss id', itemData, itemData.phaseId)
    const rect = event.target.getBoundingClientRect();
    console.log("sss handleItemClick", rect);
    if (isPopupVisible && popupData?.phaseId === itemData.id) {
      console.log('sss isHovered if')
      setPopupVisible(!isPopupVisible);
    } else {
      console.log('sss isHovered else')
      setPopupData(itemData);
      let a = event.target;
      // console.log({ a });
      
      setPopupPosition({
        // top: rect.top  + window.scrollY - 400, // Position the popup just below the span
        // left: rect.left + window.scrollX - 100,
        top: rect.height, // Position the popup just below the span
        left: rect.left + rect.width - 150,
      });
      setPopupVisible(!isPopupVisible); // Show the popup
    }
  };
  
  const Position = (event) => {
    // Get the position of the clicked span element
    const rect = event.target.getBoundingClientRect();
    // console.log(rect);
    let a = event.target;
    // console.log({ a });

    setPopupPosition({
      top: rect.height, // Position the popup just below the span
      right: rect.width,
    });
  };

  useEffect(() => {
    HELPERS.log(
      "Updated Timeline",
      sectionRef.current ? sectionRef.current.offsetWidth : null,
      marginLeft,
      joinedOn.date(),
      joinedOn.daysInMonth()
    );
    if (sectionRef.current) {
      let margin = `${
        (joinedOn.date() * sectionRef.current.offsetWidth) /
        joinedOn.daysInMonth()
      }px`;
      if (margin !== marginLeft) {
        setMarginLeft(margin);
      }
    }
  }, []);

  const updateHoursPerWeekCommitment = (value) => {
    message.success("Your work has been saved")
    dispatch(updateHoursPerWeekCommitmentAsync(value));
  };

  const openEditForm = (event, id) => {
    console.log('sss openEditForm updatedStepGoals', id.split("-")[0], parseInt(id.split("-")[0]))
    const rect = event.target.getBoundingClientRect();
    timelineStep.map((data) => {
      if(data.goalId === parseInt(id) ){
        setGoalStepID(data.goalId)
        setGoalDesc(data.goal)
        setGoalDueDate(parseInt(data.year))
        setPopupPosition({
          top: rect.height, // Position the popup just below the span
          left: rect.left + window.scrollX,
        });
        setForm2Open(true)
      }
    })
  }

  const addYearGroupIndex = (data) => {
    const yearIndexMap = new Map();
    let currentIndex = 0;
    
    return data.map((item) => {
      if (!yearIndexMap.has(item.year)) {
        yearIndexMap.set(item.year, currentIndex);
        currentIndex++;
      }
      return {
        index: yearIndexMap.get(item.year)
      };
    });
  };

  const timelineWithIndex = addYearGroupIndex(timelineStep);
  // console.log('sss timelineWithIndex', timelineWithIndex);

  const nodes = timelineStep.map((data, index) => ({
    id: `${data.goalId}-${index}`, // Ensure unique ID
    data: {
      title: `${data.goal}`,
      label: (
        <div
          className="main-label-div"
          style={{
            background: "#fff",
            padding: "0px",
            textAlign: "center",
            width: "100%",
            // height: "30px"
            height: "40px"
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "0px",
              textAlign: "left",
              maxWidth: "100%",
              // display: "-webkit-box",
            }}
          >
            <p 
            className="step-title">{data.goal}</p>
          </div>
          <div
            style={{
              background: "transparent",
              padding: "0px",
              textAlign: "center",
              maxWidth: "100%",
              position: "relative",
              // top: "28px",
              // top: "35px",
              top: "85%",
              // position: "absolute",
              // top: "60px",
            }}
            className="year-div"
          >
            <p
              style={{
                fontSize: "17px",
                color: "#6D6D6D",
                maxWidth: "100%",
                marginBottom: '0px',
              }}
            >{data.year}</p>
          </div>
        </div>
      ),
    },
    // position: { x: index * 180, y: 300 - index * 25 },
    position: { 
      x: index * 163, 
      y: 300 - timelineWithIndex[index].index * 25 
      // y: 290 - timelineWithIndex[index].index * 25 
    },
    style: {
      position: "absulute",
      background: "#fff",
      border: "3px solid #7FC1C4",
      padding: "8px 10px",
      borderTop: "2px solid #E7E7E7",
      borderLeft: "2px solid #E7E7E7",
      borderRadius: "8px",
      boxShadow: "3px 3px 7px 0px #DEDEDED1",
      // borderImage: "linear-gradient(to bottom, #E7E7E7 57%, #7FC1C4 43%) 1",
    },
    selectable: false, // Make sure the node itself is not selectable
  }));

  const edges = timelineStep.slice(0, -1).map((data, index) => ({
    id: `e${index}-${index + 1}`, // Unique edge ID
    source: `${data.goalId}-${index}`, // Match updated node IDs
    target: `${timelineStep[index + 1].goalId}-${index + 1}`,
    type: "smoothstep",
    style: {
      // pointerEvents: "none",
    },
  }));

  console.log('sss nodes', nodes, edges)

  const handleDelete = () => {
    // console.log('sss left', left)
    // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
    try {
      const payload = { "step_id": compID, "user_id": userId }
      console.log("sss delete", payload);
      DASHBOARD_API.deleteDashboardItem(payload)
      .then((response) => {
        console.log("sss delete api response", response);
        message.success("Your work has been saved")
        setTmpState(!tmpState)
      })
      .catch((err) => {
        console.log("sss delete api error", err, payload);
        message.error("Your work has not been saved")
      });
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleDeleteGoals = (id) => {

    Modal.confirm({
      title: "Deleting this Roadmap phase will also remove its corresponding Short-Term Goal.",
      content: "Proceed?",
      okText: "Yes",
      cancelText: "No",
      className: "custom-delete-timeline-modal", 
      maskClosable: true,
      onOk: () => {
        const updatedGoals = timelineData.filter(item => item.phaseId !== id);

        let updatedSTG;
        timelineData.map((timelinePhase, timelinePhaseIndex) => {
          
          if(timelinePhase.phaseId === id){
            console.log('sss handleDeleteGoals timelinePhase', timelinePhase)
            
            updatedSTG = shortTermGoals.reduce((acc, stgGoal, stgGoalIndex) => {
              console.log('sss handleDeleteGoals before', stgGoal)
              
              if (stgGoal.step.toLowerCase() === timelinePhase.phaseTitle.toLowerCase()) {
                let GoalSubTasks = stgGoal.subTasks.map(subTask => ({ ...subTask }));
                GoalSubTasks = GoalSubTasks.filter(task => {
                  return task.enddate < timelinePhase.startDate || task.enddate > timelinePhase.endDate;
                });
                
                console.log('sss handleDeleteGoals GoalSubTasks', GoalSubTasks)
                
                if (GoalSubTasks.length >= 1) {
                  acc.push({ ...stgGoal, subTasks: GoalSubTasks });
                }
                // If GoalSubTasks.length < 1, we don't add anything to acc (effectively removing the goal)
              } else {
                console.log('sss handleDeleteGoals after', stgGoal)
                acc.push(stgGoal);
              }
              
              return acc;
            }, []);

            console.log('sss handleDeleteGoals updatedSTG', updatedSTG)
          }
        })

        // return false;
        setTimeout(() => {
          dispatch(setTimelineAsync(updatedGoals, userId))
        }, 100)
        setTimeout(() => {
          dispatch(setShortTermGoalsAsync(updatedSTG, userId))
        }, 200)
        message.success("Your work has been saved")
     
      }
    });
    setTimeout(() => {
      const modalElements = document.querySelectorAll(".ant-modal");
      const latestModal = modalElements[modalElements.length - 1];
      if (latestModal) latestModal.setAttribute("data-modal-id", "custom-delete-timeline-modal");
      const btnElement = document.querySelector('.ant-modal[data-modal-id="custom-delete-timeline-modal"] .ant-btn:not(ant-btn-primary)');
      btnElement.setAttribute("type", "primary");
      btnElement.classList.add('button-secondary')
      btnElement.classList.remove('ant-btn')

      const btnElement2 = document.querySelector('.ant-modal[data-modal-id="custom-delete-timeline-modal"] .ant-btn.ant-btn-primary');
      btnElement2.setAttribute("type", "primary");
      btnElement2.classList.add('button-main')
      btnElement2.classList.remove('ant-btn')
      btnElement2.classList.remove('ant-btn-primary')
    }, 0);
    
    // console.log('sss handleDeleteGoals updatedGoals', id, updatedGoals)
  }

  const handleDeleteStepGoals = (id) => {
    const updatedStepGoals = timelineStep.filter(item => item.goalId !== id);
    // updatedStepGoals.filter(item => item.goalId !== id);
    message.success("Your work has been saved")
    dispatch(setTimelineStepAsync(updatedStepGoals, userId))
    console.log('sss handleDeleteStepGoals updatedStepGoals', id, updatedStepGoals)
    setGoalStepID(null)
    setGoalDesc('')
    setGoalDueDate('')
    setForm2Open(false)
  }

  const handleSaveGoals = async (values) => {
    // console.log('sss handleSaveGoals', values, formOpen, form2Open)
    // return false
    // setFormOpen(false)
    // setForm2Open(false)

    // Add new goal only if phaseId is null
    if(formOpen && !form2Open) {
      let updatedTimeline;
      let updatedSTG;
      let phaseExist = false;
      console.log('Add new goal only if phaseId is null 1')
      updatedTimeline = timelineData.map((item, index) => {
        // console.log('sss item', item, index)
        if(item.phaseTitle.toLowerCase() === values.phaseTitle.toLowerCase()){
          if( values.startDate.isBetween(moment(item.startDate), moment(item.endDate)) && values.endDate.isBetween(moment(item.startDate), moment(item.endDate))  ){
            phaseExist = true; 
            console.log('sss item both inBetween')         
          }
          else if( values.startDate.isBetween(moment(item.startDate), moment(item.endDate)) || ( values.startDate.diff(moment(item.endDate), "days") >= 0 && values.startDate.diff(moment(item.endDate), "days") <= 1 ) ){
            console.log('sss item startDate inBetween')         
            phaseExist = true;          
            return { ...item, endDate: values.endDate.format('YYYY-MM-DD') };
          }
          else if( values.endDate.isBetween(moment(item.startDate), moment(item.endDate)) || ( moment(item.startDate).diff(values.endDate.format('YYYY-MM-DD'), "days") >= 0 && moment(item.startDate).diff(values.endDate.format('YYYY-MM-DD'), "days") <= 1 ) ){
            phaseExist = true;
            console.log('sss item endDate inBetween', item.startDate, values.endDate.format('YYYY-MM-DD'), moment(item.startDate).diff(values.endDate.format('YYYY-MM-DD'), "days"))         
            return { ...item, startDate: values.startDate.format('YYYY-MM-DD') };
          }
          else{
            // phaseExist = false;
            // console.log('sss item compare', item.startDate < values.startDate.format('YYYY-MM-DD'), item.startDate, values.startDate.format('YYYY-MM-DD'), item.endDate > values.endDate.format('YYYY-MM-DD'), item.endDate, values.endDate.format('YYYY-MM-DD'), {
            //   ...item,
            //   startDate: item.startDate < values.startDate.format('YYYY-MM-DD') ? item.startDate : values.startDate.format('YYYY-MM-DD'),
            //   endDate: item.endDate > values.endDate.format('YYYY-MM-DD') ? item.endDate : values.endDate.format('YYYY-MM-DD')
            // })
            // return false;
            phaseExist = true;
            return {
              ...item,
              startDate: item.startDate < values.startDate.format('YYYY-MM-DD') ? item.startDate : values.startDate.format('YYYY-MM-DD'),
              endDate: item.endDate > values.endDate.format('YYYY-MM-DD') ? item.endDate : values.endDate.format('YYYY-MM-DD')
            };
          }
        }
        return item; // Return unchanged items
      })
      console.log('sss item updated before', updatedTimeline)
      
      updatedTimeline = updatedTimeline.reduce((acc, current, index) => {
        // If this is the first item, just add it
        if (acc.length === 0) {
          acc.push(current);
          return acc;
        }
        
        const previous = acc[acc.length - 1];

        // Check if current item has same phaseTitle as previous
        if (current.phaseTitle.toLowerCase() === previous.phaseTitle.toLowerCase()) {

          // Calculate day difference between previous endDate and current startDate
          const dayDiff = moment(current.startDate).diff(moment(previous.endDate), "days");
          
          // If difference is less than 1 day, merge them
          if (dayDiff >= 0 && dayDiff <= 1) {
            console.log('sss item', dayDiff, current.startDate, previous.endDate)
            // Update the previous item's endDate to current item's endDate
            // Create a new object with updated endDate
            // previous.endDate = current.endDate;
            const updatedPrevious = {
              ...previous,
              endDate: current.endDate
            };
            // Replace the last item in accumulator
            acc[acc.length - 1] = updatedPrevious;
            phaseExist = true;
            return acc;
          }
        }

        // If no merge condition met, add current item
        acc.push(current);
        return acc;
      }, [])

      console.log('sss item updated after', updatedTimeline)
      // return false

      let uniqueID = moment().valueOf() // new unique ID
      if(!phaseExist){
        console.log('sss item phaseExist', phaseExist)
        updatedTimeline.push({
          phaseId: uniqueID, 
          phaseTitle: values.phaseTitle,
          goalDescription: values.goalDescription,
          startDate: values.startDate ? moment(values.startDate).format("YYYY-MM-DD") : "",
          endDate: values.endDate ? moment(values.endDate).format("YYYY-MM-DD") : "",
        });  
      }
      
      phaseExist = false;

      updatedSTG = shortTermGoals.map((item, index) => {
        console.log('sss item shortTermGoals', item, index)

        if(item.step.toLowerCase() === values.phaseTitle.toLowerCase()){

          // let GoalSubTasks = item.subTasks;
          let GoalSubTasks = item.subTasks.map(subTask => ({ ...subTask }));

          if( values.startDate.isBetween(moment(GoalSubTasks[0].startdate), moment(GoalSubTasks[GoalSubTasks.length-1].enddate)) && values.endDate.isBetween(moment(GoalSubTasks[0].startdate), moment(GoalSubTasks[GoalSubTasks.length-1].enddate)) ){
            phaseExist = true;
            console.log('sss item shortTermGoals yes 1')
          }
          else if( ( values.startDate.diff(moment(GoalSubTasks[GoalSubTasks.length-1].enddate), "days") >= 0 && values.startDate.diff(moment(GoalSubTasks[GoalSubTasks.length-1].enddate), "days") <= 1 ) ){
            phaseExist = true;
            GoalSubTasks[GoalSubTasks.length-1].enddate = values.endDate.format('YYYY-MM-DD')
            console.log('sss item shortTermGoals yes 2')
            // return { ...item, subTasks: GoalSubTasks };
          }
          else if( ( moment(GoalSubTasks[0].startdate).diff(values.endDate.format('YYYY-MM-DD'), "days") >= 0 && moment(GoalSubTasks[0].startdate).diff(values.endDate.format('YYYY-MM-DD'), "days") <= 1 ) ){
            phaseExist = true;
            GoalSubTasks[0].startdate = values.startDate.format('YYYY-MM-DD')
            console.log('sss item shortTermGoals yes 3')
            // return { ...item, subTasks: GoalSubTasks };
          }
          else if( values.startDate.diff(moment(GoalSubTasks[GoalSubTasks.length-1].enddate), "days") > 1 || moment(GoalSubTasks[0].startdate).diff(values.endDate.format('YYYY-MM-DD'), "days") > 1 ){
            phaseExist = true;
            GoalSubTasks[GoalSubTasks.length] = {
              id: uniqueID,
              stepId: uniqueID+1,
              startdate: values.startDate ? moment(values.startDate).format("YYYY-MM-DD") : "",
              enddate: values.endDate ? moment(values.endDate).format("YYYY-MM-DD") : "",
              goal: values.goalDescription,
              status: "pending",
            }
            console.log('sss item shortTermGoals yes 4')
            // return { ...item, subTasks: GoalSubTasks };
          }
          else{
            console.log('sss item shortTermGoals yes 6')
            phaseExist = true;
          }

        }
        return item;
      })
      if(!phaseExist){
        console.log('sss item shortTermGoals yes 5')
        console.log('sss item phaseExist', phaseExist)
        updatedSTG.push({
          id: uniqueID+1,
          step: values.phaseTitle,
          subTasks: [{
            id: uniqueID,
            stepId: uniqueID+1,
            startdate: values.startDate ? moment(values.startDate).format("YYYY-MM-DD") : "",
            enddate: values.endDate ? moment(values.endDate).format("YYYY-MM-DD") : "",
            goal: values.goalDescription,
            status: "pending",
          }]
        });  
      }
      console.log('sss item updated', phaseExist, updatedTimeline, updatedSTG)
      // return false
      message.success("Your work has been saved")
      setTimeout(() => {
        dispatch(setShortTermGoalsAsync(updatedSTG, userId))
      }, 100)
      setTimeout(() => {
        dispatch(setTimelineAsync(updatedTimeline, userId))
      }, 200)
      // dispatch(setShortTermGoalsAndTimelineAsync(updatedTimeline, updatedSTG, userId))
    }
    // Update existing goal if phaseId (phaseId) matches
    else if(!formOpen && !form2Open){
      if (values?.phaseId) {
        
        let updatedTimeline = [];
        let updatedSTG = [];
        let phaseNameChange = null;
        let oldPhaseName = null
        let newPhaseName = null;

        console.log("Update existing goal if phaseId (phaseId) matches 2")
        let tmpTimelinePhaseSplit = []
        updatedTimeline = timelineData.map((item) => {
          if (item.phaseId === values.phaseId){
            if(item.phaseTitle.toLowerCase() !== values.phaseTitle.toLowerCase()){
              oldPhaseName = item.phaseTitle
              newPhaseName = values.phaseTitle
              phaseNameChange = true
              let uniqueID = moment().valueOf()

              if( moment(values.startDate).isBetween(moment(item.startDate), moment(item.endDate)) && moment(values.endDate).isBetween(moment(item.startDate), moment(item.endDate)) ){
                tmpTimelinePhaseSplit.push({
                  endDate: moment(values.startDate).add(-1, "day").format("YYYY-MM-DD"),
                  phaseId: uniqueID,
                  startDate: item.startDate,
                  phaseTitle: item.phaseTitle,
                  goalDescription: item.goalDescription,
                },{
                  endDate: item.endDate,
                  phaseId: uniqueID+1,
                  startDate: moment(values.endDate).add(1, "day").format("YYYY-MM-DD"),
                  phaseTitle: item.phaseTitle,
                  goalDescription: item.goalDescription,
                })
              }
              else if( moment(values.startDate).diff(moment(item.startDate), "days") >= 1 ){
                tmpTimelinePhaseSplit.push({
                  endDate: moment(values.startDate).add(-1, "day".format("YYYY-MM-DD")),
                  phaseId: uniqueID,
                  startDate: item.startDate,
                  phaseTitle: item.phaseTitle,
                  goalDescription: item.goalDescription,
                })
              }
              else if( moment(item.endDate).diff(moment(values.endDate), "days") >= 1 ){
                tmpTimelinePhaseSplit.push({
                  endDate: item.endDate,
                  phaseId: uniqueID,
                  startDate: moment(values.endDate).add(1, "day").format("YYYY-MM-DD"),
                  phaseTitle: item.phaseTitle,
                  goalDescription: item.goalDescription,
                })
              }
            }
            return {
              ...item,
              phaseTitle: values.phaseTitle,
              goalDescription: values.goalDescription,
              startDate: values.startDate ? moment(values.startDate).format("YYYY-MM-DD") : "",
              endDate: values.endDate ? moment(values.endDate).format("YYYY-MM-DD") : "",
            }
          }
          return item
        });

        if(tmpTimelinePhaseSplit.length > 0){
          updatedTimeline.push(...tmpTimelinePhaseSplit)
        }

        console.log('sss updatedTimeline before merge', updatedTimeline)
        // return false;
        updatedTimeline = mergeOrSplitPhase(updatedTimeline, values)
        const foundPhaseIndex = updatedTimeline.findIndex(item => item.phaseId === values.phaseId)
        console.log('sss updatedTimeline after merge', updatedTimeline, foundPhaseIndex)
        
        console.log('sss STG before split', updatedSTG, shortTermGoals)
        // return false
        // updatedSTG = phaseNameChange ? await splitAndUpdateSTG(shortTermGoals, updatedTimeline[foundPhaseIndex], oldPhaseName, newPhaseName) : null;
        let conflict = false;
        ({ STG: updatedSTG, conflict } = splitAndUpdateSTG(shortTermGoals, updatedTimeline[foundPhaseIndex], oldPhaseName, newPhaseName));
        dispatch(setShortTermGoalsConflict(conflict));
        console.log('sss STG after split', updatedSTG, conflict)
        // return false;
        if(conflict){
          return false
        }
        
        setPopupData({
          id: values.phaseId,
          title: updatedTimeline[foundPhaseIndex].phaseTitle,
          description: updatedTimeline[foundPhaseIndex].goalDescription,
          startTime: updatedTimeline[foundPhaseIndex].startDate ? moment(updatedTimeline[foundPhaseIndex].startDate, "YYYY-MM-DD") : "",
          dueTime: updatedTimeline[foundPhaseIndex].endDate ? moment(updatedTimeline[foundPhaseIndex].endDate, "YYYY-MM-DD") : "",
        });
        // console.log('sss popupData', popupData)
        message.success("Your work has been saved")
        // dispatch(setTimelineAsync(updatedTimeline, userId))
        setTimeout(() => {
          dispatch(setTimelineAsync(updatedTimeline, userId))
        }, 100)
        // phaseNameChange && setTimeout(() => {
        setTimeout(() => {
          dispatch(setShortTermGoalsAsync(updatedSTG, userId))
        }, 200)
      } 
    }
    else if(!formOpen && form2Open){
      let updatedSteps;
      if (values?.stepId) {
        // Update existing step if stepId (goalId) matches
        updatedSteps = timelineStep.map(item =>
          item.goalId === values.stepId
            ? {
                ...item,
                goal: values.stepDescription,
                year: values.endDate.year(),
              }
            : item
        );
      } else {
        // Add new step if stepId is null
        updatedSteps = [
          ...timelineStep,
          {
            goalId: moment().valueOf(), // generate new unique ID
            goal: values.stepDescription,
            year: values.endDate.year(),
          }
        ];
      }
      message.success("Your work has been saved")
      dispatch(setTimelineStepAsync(updatedSteps, userId))
    }
    setFormOpen(false)
    setForm2Open(false)
  };

  const fillGaps = (chunk, chunkStart, chunkEnd) => {
    const result = [];
    let prevEnd = moment(chunkStart);
  
    for (const item of chunk) {
      const itemStart = moment(item.startDate, "YYYY-MM-DD");
      const itemEnd = moment(item.endDate, "YYYY-MM-DD");
  
      const gapDays = itemStart.diff(prevEnd, 'days');
      if (gapDays >= 1) {
        result.push({
          startDate: prevEnd.format("YYYY-MM-DD"),
          endDate: itemStart.format("YYYY-MM-DD")
        });
      }
  
      result.push(item);
      prevEnd = itemEnd.clone().add(1, 'day');
    }
  
    const endGap = chunkEnd.diff(prevEnd, 'days');
    if (endGap >= 1) {
      result.push({
        startDate: prevEnd.format("YYYY-MM-DD"),
        endDate: chunkEnd.format("YYYY-MM-DD")
      });
    }
  
    return result;
  };

  // const fillGaps = (chunk, chunkStart, chunkEnd) => {
  //   const result = [];
  //   let prevEnd = moment(chunkStart);
  
  //   for (const item of chunk) {
  //     const itemStart = moment(item.startDate, "YYYY-MM-DD");
  //     const itemEnd = moment(item.endDate, "YYYY-MM-DD");
  
  //     const gapDays = itemStart.diff(prevEnd, 'days');
      
  //     // Check if it's a month-end to month-start gap scenario
  //     // const isMonthEndGap = prevEnd.clone().subtract(1, 'day').date() >= prevEnd.clone().subtract(1, 'day').daysInMonth() - 2 && itemStart.date() <= 4;
  //     const isMonthEndGap = false;
      
  //     // Create gap only if:
  //     // 1. It's not a month-end to month-start scenario (this takes precedence), OR
  //     // 2. If it's not month-end scenario, then gap must be 4 or more days
  //     if (!isMonthEndGap && gapDays >= 3) {
  //       result.push({
  //         startDate: prevEnd.format("YYYY-MM-DD"),
  //         endDate: itemStart.format("YYYY-MM-DD")
  //       });
  //     }
  
  //     result.push(item);
  //     prevEnd = itemEnd.clone().add(1, 'day');
  //   }
  
  //   const endGap = chunkEnd.diff(prevEnd, 'days');
  //   if (endGap >= 1) {
  //     result.push({
  //       startDate: prevEnd.format("YYYY-MM-DD"),
  //       endDate: chunkEnd.format("YYYY-MM-DD")
  //     });
  //   }
  
  //   return result;
  // };
  

  const applyFillGapsToGroups = (groups) => {
    const year = moment().year(); // Or get year dynamically from your data
    const month = moment().month(); // Or get year dynamically from your data
    console.log('sss month ', month)
    const now = moment();
    // const startMoment = moment(`${year}-${month}-01`, "YYYY-MM-DD");
    // const endMoment = moment(`${year}-${month+12}-31`, "YYYY-MM-DD");
    const startMoment = now.clone().startOf('month'); // 1st day of current month
    const endMoment = now.clone().add(11, 'months').endOf('month'); // last day of the 12th month
  
    return groups.map((chunk) => {
      return fillGaps(chunk, startMoment, endMoment);
    });
  };
  

  const rearrangeData = (data) => {

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const startBoundary = new Date(currentYear, currentMonth, 1); // 1st of current month
    const endBoundary = new Date(currentYear, currentMonth + 12, 0); // last day of the 12th month

    const sortedData = [...data]
      .map(item => {
        const itemStart = new Date(item.startDate);
        const itemEnd = new Date(item.endDate);

        const adjustedStart = itemStart < startBoundary ? startBoundary : itemStart;
        const adjustedEnd = itemEnd > endBoundary ? endBoundary : itemEnd;

        return {
          ...item,
          adjustedStart,
          adjustedEnd
        };
    
        // const adjustedStart =
        //   itemStart.getFullYear() < currentYear
        //     ? `${currentYear}-01-01`
        //     : itemStart;
    
        // const adjustedEnd =
        //   itemEnd.getFullYear() > currentYear
        //     ? `${currentYear}-12-31`
        //     : itemEnd;
    
        // return {
        //   ...item,
        //   adjustedStart,
        //   adjustedEnd
        // };
      })
      .filter(item => {
        // const itemYear = new Date(item.adjustedStart).getFullYear();
        // const itemEndYear = new Date(item.adjustedEnd).getFullYear();
        // return itemYear === currentYear && itemEndYear === currentYear;

        const itemStart = new Date(item.adjustedStart);
        const itemEnd = new Date(item.adjustedEnd);
        return itemEnd >= startBoundary && itemStart <= endBoundary;
      })
      .sort((a, b) => {
        return new Date(a.adjustedStart) - new Date(b.adjustedStart);
      });
    // Function to check overlap
    // const isOverlapping = (a, b) => new Date(b.startDate) <= new Date(a.endDate);
    const isOverlapping = (a, b) => new Date(b.adjustedStart) <= new Date(a.adjustedEnd);
  
    // Grouping logic
    const groups = [];
  
    for (const item of sortedData) {
      let placed = false;
  
      for (const group of groups) {
        const lastItem = group[group.length - 1];
  
        if (!isOverlapping(lastItem, item)) {
          group.push(item);
          placed = true;
          break;
        }
      }
      if (!placed) {
        groups.push([item]);
      }
    }
    const filledGroups = applyFillGapsToGroups(groups);
    console.log('sss timeline', sortedData, groups, filledGroups)
    return filledGroups;
  }

  const handleItemHover = (event, itemData) => {
    // Get the position of the clicked span element
    console.log('sss isHovered id', itemData, isPopupVisible)
    const rect = event.target.getBoundingClientRect();
    // console.log(rect);
    if (itemData.id === null || itemData.id === undefined) {
      console.log('sss isHovered if')
      setPopupVisible(false);
      setPopupData(null);
      setPopupPosition(null)
      setPopupPosition({top: 0, left: 0})
    } else {
      console.log('sss isHovered else', rect, itemData)
      setPopupData(itemData);
      setPopupPosition({
        // top: rect.height - 25, // Position the popup just below the span
        // left: rect.left - 140,
        top: rect.top + window.scrollY - 440,
        left: rect.left + window.scrollX - 133,
        // left: rect.right,
        // top: rect.height,
        // left: rect.left
      });
      setPopupVisible(true); // Show the popup
    }
  }

  const renderTimelineRows = (data, handleItemClick) => {
    console.log('sss timeline rearrangeData(data)', data, rearrangeData(data).reverse())
    const chunkedData = rearrangeData(data).reverse();
    
    console.log('sss chunkedData', chunkedData)
  
    const result = chunkedData.map((chunk, i) => {
      // console.log('sss timeYearsList profile', chunk, joinedOn);
      // timeYearsList.map((year, index) => {
      //   console.log('sss timeYearsList year', year, index);
      // })
      let num = 0.1
      let lgr = 9
      let lgg = 188
      let lgb = 201
      return (
        <div className="timeline section" key={`row-${i}`}>

          {chunk.map((item, index) => {
            const start = item.phaseId ? moment(item.adjustedStart, "YYYY-MM-DD") : moment(item.startDate, "YYYY-MM-DD");
            const end = item.phaseId ? moment(item.adjustedEnd, "YYYY-MM-DD") : moment(item.endDate, "YYYY-MM-DD");

            // console.log('sss daysUsed setTimelinePercentage', item)
            // const { width, dayDiff } = newGetWidth(start, end);
            const { width, dayDiff, previousDayDiff, nextDayDiff, totalFraction } = setTimelinePercentage(start, end, item, chunk[index-1], chunk[index+1]);
            
            const text = item.phaseTitle;
            const font = "17px AvenirBook";
            const textWidth = getTextWidth(text, font);
            // const nodeElement = document.querySelector(`duration-${dayDiff}`);
            // const nodeElementWidth = nodeElement.offsetWidth;
            console.log('sss dayDiff textWidth', item.phaseTitle, width, textWidth)

            if(!item.phaseId) {
              const dayDiff = end.diff(start, 'days');
              if (dayDiff < 7) {
                return null;
              }
            }
            if(item.phaseId) {
              // num += 0.1
              // lgr -= 1
              // lgg -= 21
              // lgb -= 21

              num = Math.round( (num < 0.9 ? num + 0.05 : num) * 10) / 10
              // num = 0.2
              lgr = lgr > 1 ? lgr - 1 : lgr
              // lgg -= 8
              // lgb -= 8
              lgg = lgg > 69 ? lgg - 8 : lgg - 4
              lgb = lgb > 81 ? lgb - 8 : lgb - 4     

            }
            const background = `linear-gradient(90deg, rgba(${lgr}, ${lgg}, ${lgb}, ${num}) 0%, rgba(255, 255, 255, 0.2) 183.46%)`;
            const borderLeft = "2px solid #199094";
            return (
              <>
                <span
                  key={index}
                  index={i}
                  data-title={item.phaseTitle}
                  data-dayDiff={dayDiff}
                  data-previousDayDiff={previousDayDiff}
                  data-nextDayDiff={nextDayDiff}
                  data-totalFraction={totalFraction}
                  className={`portion duration-${dayDiff} ${!item.phaseId ? "blank-spance" : "phase"}`}
                  style={{ width: `${width}%`, cursor: item.phaseId ? "pointer" : "", padding: `${width <= 3.05556 ? "0px" : ""}`, background: item.phaseId ? background : "", borderLeft: item.phaseId ? num > 0.2 ? borderLeft : "" : "" }}
                  onMouseEnter={(event) => {
                    event.stopPropagation();
                    dispatch(setShortTermGoalsConflict(false));
                    handleItemHover(event, {
                      id: item.phaseId,
                      title: item.phaseTitle,
                      description: item.goalDescription,
                      startTime: moment(item.startDate, "YYYY-MM-DD"),
                      dueTime: moment(item.endDate, "YYYY-MM-DD"),
                    });
                  }}
                  // onMouseLeave={(event) => {
                  //   event.stopPropagation();
                  //   item.phaseId && handleItemHover(event, {
                  //     id: null,
                  //   });
                  // }}
                  onClick={(event) => {
                    event.stopPropagation();
                    dispatch(setShortTermGoalsConflict(false));
                    item.phaseId && handleItemClick(event, {
                      id: item.phaseId,
                      title: item.phaseTitle,
                      description: item.goalDescription,
                      startTime: moment(item.startDate, "YYYY-MM-DD"),
                      dueTime: moment(item.endDate, "YYYY-MM-DD"),
                    });
                  }}
                  // title={item.phaseTitle}
                >
                  <div>{item.phaseTitle}</div>
                </span>
                {/* {
                  item.phaseId &&
                  <RoadmapDisplayTitle phaseTitle={item.phaseTitle} width={width} />
                } */}
              </>
            );
          })}
        </div>
      );
    });
    return result
  };

  useEffect(() => {
    // if(!isExpanded){
    //   renderTitleHoverElement()
    // } ;
  }, [isExpanded])

  const removePhaseName = () => {
    const phases = document.querySelectorAll("span.phase");
    console.log('sss maxWidth phases', phases)
  
    phases.forEach((span, index) => {
      // const spanWidth = span.getBoundingClientRect().width; // more accurate than offsetWidth
      const spanWidth = span.offsetWidth;
  
      const computedStyle = window.getComputedStyle(span);
      const font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
      const text = span.getAttribute('data-title').trim();
      const dayDiff = span.getAttribute('data-dayDiff');
      const textWidth = getTextWidth(text, font)+1;
      // const textWidth = getTextWidthInDecimals(text, font);
  
      console.log(`sss maxWidth Phase`, span);
      console.log(`sss maxWidth - Span width (box): ${spanWidth}px`);
      console.log(`sss maxWidth - Text [ ${text} Span width: ${spanWidth}px ] Text width: ${textWidth}px`);
      
      // span.style.color = '';
      // span.style.textIndent = '';
      const diffWidth = (textWidth - spanWidth)
      const percentExtra = parseFloat(((diffWidth / spanWidth) * 100)).toFixed(2)
      // console.log(`sss maxWidth - Text [ ${text} diffWidth: ${diffWidth}px ] percentExtra: ${percentExtra}%`, percentExtra > 27.27);
      if( ( textWidth > (spanWidth) ) && ( diffWidth > 15 ) && dayDiff <= 19 ){
        // if( textWidth > (spanWidth) && percentExtra > 27.27 ){
        console.log('sss maxWidth if', textWidth, text, spanWidth)
        // span.style.color = 'transparent';
        // span.style.textIndent = '-999px'
        // span.textContent = ""
        span.firstChild.style.display = "none"
      }
      else{
        // span.textContent = text;
        span.firstChild.style.display = ""
        span.firstChild.textContent = text
      }
    });
  }
    
  useEffect(() => {
    setTimeout(() => {
      removePhaseName();
    }, 400)
  }, [timelineData])
  useEffect(() => {
    removePhaseName();
  }, [isExpanded])

  // const renderTitleHoverElement = () => {
  //   const nodeElement = document.querySelectorAll(`.portion.phase`);

  //   let titleElement = []
  //   nodeElement.forEach((item, index) => {
  //     const nodeElementWidth = item.offsetWidth;
    
  //     const computedStyle = window.getComputedStyle(item);
  //     const font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
  //     const nodeElementText = item.textContent;
  //     const nodeElementTextWidth = getTextWidth(nodeElementText, font)
  //     // Get parent's first child
  //     const parentFirstChild = item.parentElement?.firstElementChild;
  //     // console.log('nodeElement', item, index, nodeElementWidth, nodeElementText, nodeElementTextWidth)
      
  //     if( nodeElementWidth < nodeElementTextWidth ){
  //       console.log('nodeElement if', item, nodeElementWidth, nodeElementText, nodeElementTextWidth)

  //       const indexPos = parseInt(item.getAttribute('index'));

  //       // ✅ Initialize the array if it doesn't exist
  //       if (!Array.isArray(titleElement[indexPos])) {
  //         titleElement[indexPos] = [];

  //         if (parentFirstChild && parentFirstChild.classList.contains('blank-spance')) {
  //           titleElement[indexPos].push(
  //             <span 
  //               key={`blank-${indexPos}-0`}
  //               className="portion blank-spance"
  //               blank={1}
  //               width={parentFirstChild.offsetWidth}
  //               phaseTitle={''}
  //               style={{ width: `${parentFirstChild.offsetWidth}px` }}
  //             />
  //           )
  //         }
  //       }

  //       titleElement[indexPos].push(
  //         <RoadmapDisplayTitle
  //           key={`title-${indexPos}-${titleElement[indexPos].length}`}
  //           phaseTitle={nodeElementText}
  //           width={nodeElementTextWidth}
  //         />
  //       )
  //     }
  //   })
  //   // console.log('nodeElement', titleElement)
  //   const denseTitleElement = titleElement.filter(row => Array.isArray(row)).reverse();
  //   // console.log('nodeElement denseTitleElement', titleElement, denseTitleElement)
    
  //   const timelineElement = document.querySelectorAll(`.timeline.section.blank`)
  //   // console.log('nodeElement timelineElement', timelineElement, denseTitleElement)

  //   for( let i = 0 ; i <= denseTitleElement.length - 1 ; i++ ){

  //     const elePos = (timelineElement.length - 1 - i)
  //     timelineElement[elePos].innerHTML = '';
  //     for (let k = 0; k <= denseTitleElement[i].length - 1; k++) {
  //       const item = denseTitleElement[i][k];
  //       console.log('nodeElement item',item)
  //       if(item.props.blank){
  //         const titleDiv = document.createElement('div');
  //         titleDiv.textContent = item.props.phaseTitle;
  //         titleDiv.style.width = `${item.props.width}px`;
  //         timelineElement[elePos].appendChild(titleDiv);
  //       }
  //       else{
  //         console.log('nodeElement timelineElement', i, k)

  //         const titleDiv = document.createElement('div');
  //         // titleDiv.innerHTML = `<span>${item.props.phaseTitle}</span>`
  //         titleDiv.classList.add('phaseTitleHover', i, k)
  //         titleDiv.setAttribute("i", i)
  //         titleDiv.setAttribute("k", k)
  //         titleDiv.textContent = item.props.phaseTitle;
  //         // titleDiv.style.width = `${item.props.width}px`;
  //         timelineElement[elePos].appendChild(titleDiv);
  //         // timelineElement[elePos].appendChild(titleDiv);
  //         setDynamicHeight(i, k, item.props.phaseTitle)
  //       }
  //     }
  //   }
  // }

  const setDynamicHeight = (a, b, title) => {
    console.log('referenceElement', a, b);
    const referenceElement1 = document.querySelector(`.phaseTitleHover[i="${a}"][k="${b}"]`);
    const referenceElement2 = document.querySelector(`.portion.phase[title="${title}"]`);
    
    console.log('referenceElement', referenceElement1, referenceElement1?.getBoundingClientRect(), referenceElement2, referenceElement2?.getBoundingClientRect());
    
    if (referenceElement1 && referenceElement2) {
      const rect1 = referenceElement1.getBoundingClientRect();
      const rect2 = referenceElement2.getBoundingClientRect();
      const height = Math.abs(rect2.y - rect1.y - rect1.height); // Distance between bottom of element1 and top of element2
      
      console.log('referenceElement height', height, rect1, rect2);
      
      // Set CSS custom property for this specific element's ::after pseudo-element
      referenceElement1.style.setProperty('--after-height', `${height}px`);
      
      // Optional: Also set the dot position
      referenceElement1.style.setProperty('--dot-top', `${rect2.right}px`);
    }
  }
  
  return (
    <Card
      bordered={false}
      style={{
        boxShadow: "0px 3px 16px 0px #1313131A",
        borderRadius: "12px",
        textAlign: "left",
        margin: "0px 20px",
        height: "fit-content",
      }}
    >
      <div className="h" style={{
        fontWeight: "800",
        color:"#111111",
        fontFamily:'AvenirBook',
        fontSize: "18px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gridGap: "12px",
        gap: "12px",
      }}>
        
        <div className="div-my-career-roadmap-title">
            {/* Future Release Build */}
            <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg" className="" />
            <span className="my-career-roadmap-title">My Career Roadmap</span>
        </div>
        <div
          className=""  //Future Release Build
          style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "8px",
          }}
          >
            {
              isDropdownOpen ? (
                <img
                  src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                  alt="delete icon"
                  className="delete-icon"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={handleDelete}
                />
              ) : (
                <>
                <button
                  type="primary"
                  size="large"
                  className="button-main my-career-roadmap-add-new-phase-button"
                  onClick={(event) => {
                    event.stopPropagation();
                    Position(event);
                    if(!isExpanded) {
                      dispatch(setShortTermGoalsConflict(false));
                      setFormOpen(!formOpen);
                      setPopupVisible(false);
                      setForm2Open(false);
                    }
                    else {
                      setGoalStepID(null)
                      setGoalDesc("")
                      setGoalDueDate(parseInt(""))
                      setForm2Open(!form2Open)
                      setFormOpen(false);
                      setPopupVisible(false);
                    }
                    // setFormOpen(!formOpen);
                    // setPopupVisible(false);
                    // setForm2Open(false);
                    // setIsExpanded(false);
                  }}
                  ><PlusOutlined /> {!isExpanded ? "Add New Phase" : "Add New Step"}</button>
                  {formOpen && (
                    <EditCardPopup
                      id={null}
                      title={""}
                      description={""}
                      dueTime={""}
                      startTime={""}
                      onCancel={() => {
                        setFormOpen(false)
                      }}
                      onSubmit={handleSaveGoals}
                      position={popupPosition}
                      isPopupVisibleRef={isPopupVisibleRef}
                    />
                  )}
                  {form2Open && (

                    <EditCardPopup2 
                      id={goalStepID || null}
                      description={goalDesc || ""}
                      dueTime={goalDueDate || ""}
                      onCancel={() => {
                        setForm2Open(false)
                      }}
                      onSubmit={handleSaveGoals}
                      position={popupPosition}
                      isPopupVisibleRef={isPopupVisibleRef}
                      onDelete={handleDeleteStepGoals}
                    />
                  )}
                <img style={{cursor: "pointer"}} src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/myCareerRoadmapMaxIcon.svg" onClick={() => { 
                  setIsExpanded(!isExpanded);
                  setFormOpen(false);
                  setPopupVisible(false);
                  }} />
                </>
              ) 
            }
        </div>
      </div>
      <br />
      {isExpanded ? (
        <StaircaseFlow nodes={nodes} edges={edges} openEditForm={openEditForm} isExpanded={isExpanded} />
      ) : (
        <div className="woken-progress">
          <div className="timeline section blank"
            onMouseEnter={(event) => {
              event.stopPropagation();
              handleItemHover(event, {
                id: null,
              });
            }}
            onMouseLeave={(event) => {
              event.stopPropagation();
              handleItemHover(event, {
                id: null,
              });
            }}>
          </div>
           <div className="timeline section blank"
            onMouseEnter={(event) => {
              event.stopPropagation();
              handleItemHover(event, {
                id: null,
              });
            }}
            onMouseLeave={(event) => {
              event.stopPropagation();
              handleItemHover(event, {
                id: null,
              });
            }}>
          </div>
          <div className="timeline section blank"
            onMouseEnter={(event) => {
              event.stopPropagation();
              handleItemHover(event, {
                id: null,
              });
            }}
            onMouseLeave={(event) => {
              event.stopPropagation();
              handleItemHover(event, {
                id: null,
              });
            }}>
          </div>
          {
            renderTimelineRows(timelineData, handleItemClick, removePhaseName)
          }
          {/* {
            removePhaseName()
          } */}
          {/* <div className="months section" style={{ textAlign: "center" }}> */}
          <div className="months section">
            {/* {getMonthsWithYears(moment()).map((monthYear, index) => ( */}
            {getMonthsWithYearsFromCurrent(moment()).map((monthYear, index) => (
              <div className={`month month-${index} `} key={index}>
                <span>{monthYear.month}</span>
                <span>{monthYear.year}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <br />
      {isPopupVisible && popupData && (
        <TimelineCardPopup
          id={popupData.id}
          title={popupData.title}
          description={popupData.description}
          dueTime={popupData.dueTime}
          startTime={popupData.startTime}
          position={popupPosition}
          isPopupVisibleRef={isPopupVisibleRef}
          setPopupVisible={setPopupVisible}
          setFormOpen={setFormOpen}
          onSubmit={(values) => {
            handleSaveGoals(values)
          }}
          onDelete={(values) => {
            handleDeleteGoals(values)
          }}
        />
      )}
      {/* <div className="commit-hours-sec">
        I commit
        <Select
          defaultValue="1"
          bordered={false}
          style={{ color: "#32AAB0" }}
          listHeight={120}
          value={profile ? profile.hours_per_week_commitment : null}
          onChange={updateHoursPerWeekCommitment}
        >
          {Array.apply(null, { length: 30 }).map((item, index) => (
            <Option key={`option-item-${index}`} value={index + 1}>
              {index + 1}
            </Option>
          ))}
        </Select>
        hours per week to my process.
      </div> */}
    </Card>
  );
};

export default Timeline;
